import { render } from "./App.vue?vue&type=template&id=0645d439"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0645d439&lang=css"

import exportComponent from "../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__